/**
 * Checks if track's facing mode indicates user-facing camera. If facing mode isn't defined
 * it infers the mode from other track properties.
 */
export function isUserFacingVideoTrack(track) {
    return (track.kind === 'video' &&
        !track.isScreenShare &&
        (track.getSettings().facingMode === 'user' ||
            /facetime hd camera|integrated/i.test(track.label)));
}
